package com.isaias.fyattravel.web.data

/**
 * Web data models for API responses and UI state
 */

data class WebProduct(
    val id: String,
    val title: String?,
    val description: String?,
    val thumbnail: String?,
    val category: String?,
    val createdAt: Long?,
    val priceUsd: Int?,
    val priceUgx: Int?,
    val badge: String? = null,
    val discountPercent: Int? = null,
    val airlineCode: String? = null,
    val originalPriceUsd: Int? = null,
    val originalPriceUgx: Int? = null,
)

data class WebFlight(
    val id: String,
    val airlineCode: String,
    val flightNumber: String,
    val origin: String,
    val destination: String,
    val departureIso: String,
    val arrivalIso: String,
    val duration: String,
    val stops: Int,
    val priceTotal: String?,
    val currency: String?,
)

data class WebHotel(
    val id: String,
    val name: String?,
    val city: String?,
    val countryCode: String?,
    val imageUrl: String?,
    val reviewScore: Double?,
    val reviewCount: Int?,
    val price: Double?,
    val currency: String?,
)

data class WebCarRental(
    val name: String?,
    val type: String?,
    val seats: Int?,
    val transmission: String?,
    val fuel: String?,
    val imageUrl: String?,
    val price: Double?,
    val currency: String?,
    val provider: String?,
    val pickupCity: String?,
    val dropoffCity: String?,
)

data class WebCategory(
    val name: String,
    val count: Int,
)

// Checkout/Payment data classes
data class CheckoutItem(
    val id: String,
    val title: String,
    val description: String?,
    val priceUsd: Int,
    val priceUgx: Int,
    val quantity: Int = 1,
    val imageUrl: String?,
    val type: String // "product", "flight", "hotel", "car"
)

data class CustomerInfo(
    val firstName: String,
    val lastName: String,
    val email: String,
    val phoneNumber: String,
    val address: String? = null,
    val city: String? = null,
    val countryCode: String = "UG"
)

data class OrderSummary(
    val items: List<CheckoutItem>,
    val subtotalUsd: Int,
    val subtotalUgx: Int,
    val feesUsd: Int = 0,
    val feesUgx: Int = 0,
    val totalUsd: Int,
    val totalUgx: Int,
    val currency: String = "USD"
)
